"use client";

import { Center, Flex, Text } from "@chakra-ui/react";
import EmptyState from "../EmptyState/EmptyState";
import { Button } from "@/_components/lib/ui/button";
import { NextLink } from "../NextLink";
import { useTranslations } from "next-intl";

export const NotFoundComponent = () => {
  const t = useTranslations("error.404");

  return (
    <Center h="100vh" flexDir="column">
      <Flex flexDir="column" align="center" justify="center">
        <EmptyState
          title={t("title")}
          description=""
          placeholderImage="searching-looking"
          isDescription={false}
        >
          <Text
            fontSize="sm"
            fontWeight="semibold"
            fontFamily="body"
            color="neutral.700"
            textAlign="center"
          >
            {t("description")}{" "}
            <NextLink
              href="mailto:service@knoot.ai"
              color="primary.500"
              fontWeight="bold"
              _hover={{ textDecoration: "underline" }}
            >
              service@knoot.ai
            </NextLink>
          </Text>
        </EmptyState>
        <Button asChild colorPalette="primary">
          <NextLink textDecor="none" href="/">
            {t("go_home")}
          </NextLink>
        </Button>
      </Flex>
    </Center>
  );
};
